import type { FC } from 'react';
import type { CMSTextContent } from '@/api/cms/restrictions';
import { useMatchingSection } from '@/modules/restrictions/hooks/useAccessSection';
import { ScTextContentByGroup } from './styled';

interface ITextContentByGroup {
  sections: CMSTextContent[];
  className?: string;
}

export const TextContentByGroup: FC<ITextContentByGroup> = ({
  sections,
  className,
}) => {
  const section = useMatchingSection(sections);
  const pageDescriptionText = section?.content;

  if (!pageDescriptionText) return null;

  return (
    <ScTextContentByGroup
      className={className}
      dangerouslySetInnerHTML={{ __html: pageDescriptionText }}
    />
  );
};
